import styled from "styled-components";

export const Container = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;

  input,
  select {
    padding: 8px;
    margin-bottom: 8px;
  }
`;
